export const GET_CASE_DETAILS_REQUEST = "CASE_DETAILS/GET_CASE_DETAILS_REQUEST";
export const GET_CASE_DETAILS_SUCCESS = "CASE_DETAILS/GET_CASE_DETAILS_SUCCESS";
export const GET_CASE_DETAILS_FAILURE = "CASE_DETAILS/GET_CASE_DETAILS_FAILURE";

export const GET_AVAILABLE_UNITS_REQUEST = "CASE_DETAILS/GET_AVAILABLE_UNITS_REQUEST";
export const GET_AVAILABLE_UNITS_SUCCESS = "CASE_DETAILS/GET_AVAILABLE_UNITS_SUCCESS";
export const GET_AVAILABLE_UNITS_FAILURE = "CASE_DETAILS/GET_AVAILABLE_UNITS_FAILURE";

export const EDIT_CASE_DETAILS_REQUEST = "CASE_DETAILS/EDIT_CASE_DETAILS_REQUEST";
export const EDIT_CASE_DETAILS_SUCCESS = "CASE_DETAILS/EDIT_CASE_DETAILS_SUCCESS";
export const EDIT_CASE_DETAILS_FAILURE = "CASE_DETAILS/EDIT_CASE_DETAILS_FAILURE";

export const CANCEL_CASE_REQUEST = "CASE_DETAILS/CANCEL_CASE_REQUEST";
export const CANCEL_CASE_SUCCESS = "CASE_DETAILS/CANCEL_CASE_SUCCESS";
export const CANCEL_CASE_FAILURE = "CASE_DETAILS/CANCEL_CASE_FAILURE";


// WEBPACK FOOTER //
// ./src/containers/Layouts/User/CaseDetails/constants.js